import { Stack } from 'expo-router';

import { useMenuTabStackOptions } from '../../../routing';

// ─────────────────────────────────────────────────────────────────────────────

export default function MenuTabLayout() {
  const options = useMenuTabStackOptions();

  return (
    <Stack screenOptions={options.Stack}>
      <Stack.Screen name="menu/index" />
      <Stack.Screen name="locations/index" options={options.Locations} />
    </Stack>
  );
}
